(function () {
  angular.module('binky.core.user.authenticated-user', [
    'binky.core.common.member.type',
    'binky.core.common.model.cache',
    'binky.core.lodash',
    'binky.core.user.roles',
  ]);
})();
